<div class="pull-left">
  <a (click)="back()"  class="btn btn-w-md btn-line-info"><i class="fa fa-undo"></i> {{cancelText | translate}}</a>
</div>
<div *ngIf="showSave" class="pull-right">
  <button type="submit" class="btn btn-w-md btn-line-success"><i class="fa fa-check"></i> {{'general.save' | translate}}</button>
</div>
